import { render, staticRenderFns } from "./talk_fushen.vue?vue&type=template&id=a95eb518&scoped=true&"
import script from "./talk_fushen.vue?vue&type=script&lang=js&"
export * from "./talk_fushen.vue?vue&type=script&lang=js&"
import style0 from "./talk_fushen.vue?vue&type=style&index=0&id=a95eb518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95eb518",
  null
  
)

export default component.exports